import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FieldItemProps } from "apis/field";
import { FormItemProps } from "apis/form";
import { PaginationProps } from "utils/types/API";

export interface FormState {
    loading: boolean;
    list: {
        data: FormItemProps[];
        options: FormItemProps[];
        accessAllow: FormItemProps[];
        pagination?: PaginationProps;
    };
    item: {
        data?: FormItemProps;
    };
}

const initialState: FormState = {
    loading: false,
    list: {
        data: [],
        options: [],
        accessAllow: []
    },
    item: {
    }
};

interface IndexProps {
    data: FormItemProps[];
    pagination?: PaginationProps;
}
interface ItemProps {
    data?: FormItemProps;
}


interface FieldIndexProps {
    data: FieldItemProps[];
    form?: FormItemProps;
}
export const formSlice = createSlice({
    name: "form",
    initialState,
    reducers: {
        loading: (state) => {
            state.loading = true;
        },
        endLoading: (state) => {
            state.loading = false;
        },
        index: (state, action: PayloadAction<IndexProps>) => {
            state.loading = false;
            state.list.data = action.payload.data;
            state.list.pagination = action.payload.pagination;
        },
        options: (state, action: PayloadAction<IndexProps>) => {
            state.loading = false;
            state.list.options = action.payload.data;
        },
        accessAllow: (state, action: PayloadAction<IndexProps>) => {
            state.list.accessAllow = action.payload.data;
        },
        find: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
        },
        create: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
        },
        update: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
            state.list.data = state.list.data.map(item => item.id === action.payload.data?.id ? action.payload.data : item);
        },

        fieldIndex: (state, action: PayloadAction<FieldIndexProps>) => {
            // state.loading = false;
            // state.list.data = action.payload.data;
            // state.list.pagination = action.payload.pagination;

            state.loading = false;
            if (state.item.data?.id === action.payload.form?.id && state.item.data) {
                state.item.data = {
                    ...state.item.data,
                    fields: action.payload.data
                }
            }
            else {
                if (action.payload.form) {
                    state.item.data = {
                        ...action.payload.form,
                        fields: action.payload.data
                    }
                }
            }
        },
        fieldCreate: (state, action: PayloadAction<ItemProps>) => {
            // state.loading = false;
            // state.list.data = action.payload.data;
            // state.list.pagination = action.payload.pagination;
        },
        fieldUpdate: (state, action: PayloadAction<ItemProps>) => {
            // state.loading = false;
            // state.item.data = action.payload.data;
            // state.list.data = state.list.data.map(item => item.id === action.payload.data?.id ? action.payload.data : item);
        },
        fieldRemove: (state, action: PayloadAction<ItemProps>) => {
            // state.loading = false;
            // state.item.data = action.payload.data;
            // state.list.data = state.list.data.map(item => item.id === action.payload.data?.id ? action.payload.data : item);
        },
    },
});

export const { loading, endLoading, index, options, accessAllow, find, create, update, fieldIndex, fieldCreate, fieldUpdate, fieldRemove, } = formSlice.actions;
export default formSlice.reducer;
